module.exports = __webpack_public_path__ + "static/media/fpi-2-2-18.f8b571dd.png";